import { r as registerInstance, h, H as Host } from './index-DFuxYijk.js';
import { R as ReportItem } from './report-row-DRidYJeH.js';

const PaginatedReportItems = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /** The list of service documents to display */
        this.items = [];
        /** Whether the component is used on a machine page */
        this.isOnMachinePage = false;
        this.visibleAmount = PaginatedReportItems.pageSize;
    }
    /**
     * Load more items when the button is clicked
     */
    loadMore() {
        this.visibleAmount += PaginatedReportItems.pageSize;
    }
    render() {
        return (h(Host, { key: '873e5cb982e0a56bc1984edbd4ca822a96336267' }, this.items.slice(0, this.visibleAmount).map((doc) => (h("div", { class: "ux-info-box" }, h(ReportItem, { t: this.t, document: doc, title: this.t(`mf-service-calls:serviceReports.reportTypes.${doc.mission.assignmentType}`), isOnMachinePage: this.isOnMachinePage })))), this.visibleAmount < this.items.length && (h("ux-button", { key: 'b39a7910b7b8f9caf0273bae198a6d453d5a6132', class: "mf-service-reports__load-more", onClick: () => this.loadMore() }, this.t("mf-service-calls:serviceReports.loadMore")))));
    }
};
PaginatedReportItems.pageSize = 5;

export { PaginatedReportItems as mf_service_reports_paginated_items };
//# sourceMappingURL=mf-service-reports-paginated-items.entry.js.map

//# sourceMappingURL=mf-service-reports-paginated-items.entry.js.map